module.exports = __webpack_public_path__ + "static/media/virtual_e_training_gray@3x.bc9c3fbd.png";